import { Typography } from '@crossnokaye/ux-common';

import { Stack } from '@/ux-common/components/stack/stack';

export const EmptySelectionsList = () => {
  return (
    <Stack className="p-4 text-sm text-muted-foreground text-center">
      <Typography variant="body">No devices with trend points found for this facility</Typography>
    </Stack>
  );
};
